module.exports = __webpack_public_path__ + "media/images/story/icon/list-3b3b2cd43f80693df9b6f1e85a5c9010.svg";